import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Globe2 } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-stone-950 text-stone-300 mt-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <img
              src="/globezing-logo-256.png"
              srcSet="/globezing-logo-256.png 1x, /globezing-logo-512.png 2x"
              alt="Globezing"
              width="64"
              height="64"
              loading="lazy"
              className="w-16 h-16 rounded-full object-contain ring-1 ring-stone-700/60"
            />
            <div>
              <p className="font-serif text-3xl tracking-tight text-white leading-none">Globezing<span className="text-[#9c4122]">.</span></p>
              <p className="kicker text-stone-500 mt-2">Since 2014</p>
            </div>
          </div>
          <h3 className="font-serif text-4xl sm:text-5xl font-light leading-tight mt-8 text-white">
            Think Global.
            <br />
            Live Local.
          </h3>
          <p className="mt-4 text-[11px] tracking-[0.35em] uppercase text-[#9c4122] font-medium">
            Postpone Nothing
          </p>
          <p className="mt-6 text-stone-400 text-[15px] leading-relaxed max-w-md">
            A slow-travel journal from Ashwini &amp; Hemant — suitcases, month-long apartments, farmers' markets, and the people we meet along the way.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="kicker text-stone-500">Explore</p>
          <ul className="mt-4 space-y-3">
            <li><Link to="/" className="link-underline text-stone-200">Home</Link></li>
            <li><Link to="/destinations" className="link-underline text-stone-200">Destinations</Link></li>
            <li><Link to="/about" className="link-underline text-stone-200">About</Link></li>
            <li><Link to="/contact" className="link-underline text-stone-200">Contact</Link></li>
          </ul>
          <p className="kicker text-stone-500 mt-8">Popular</p>
          <ul className="mt-4 flex flex-wrap gap-x-4 gap-y-2 text-sm">
            {["italy","france","belgium","germany","caribbean","ecuador"].map((s) => (
              <li key={s}>
                <Link to={`/category/${s}`} className="link-underline text-stone-300 capitalize">{s.replace("-", " ")}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="kicker text-stone-500">Elsewhere</p>
          <ul className="mt-4 space-y-3">
            <li className="flex items-center gap-3 text-stone-200"><Instagram size={16} /> <span>@globezing</span></li>
            <li className="flex items-center gap-3 text-stone-200"><Mail size={16} /> <span>hello@globezing.com</span></li>
            <li className="flex items-center gap-3 text-stone-200"><Globe2 size={16} /> <span>www.globezing.com</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-stone-500 tracking-wider">
          <p>© {new Date().getFullYear()} Globezing — Travel stories from the slow road.</p>
          <p>Crafted with care. Photographed on the move.</p>
        </div>
      </div>
    </footer>
  );
}
